/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DurationSeconds1 } from './DurationSeconds1';
import {
    DurationSeconds1FromJSON,
    DurationSeconds1FromJSONTyped,
    DurationSeconds1ToJSON,
} from './DurationSeconds1';
import type { Note2 } from './Note2';
import {
    Note2FromJSON,
    Note2FromJSONTyped,
    Note2ToJSON,
} from './Note2';
import type { SignedUrl } from './SignedUrl';
import {
    SignedUrlFromJSON,
    SignedUrlFromJSONTyped,
    SignedUrlToJSON,
} from './SignedUrl';

/**
 * Media file metadata returned by upload and get endpoints.
 * @export
 * @interface MediaFile
 */
export interface MediaFile {
    /**
     * Media file UUID
     * @type {string}
     * @memberof MediaFile
     */
    id: string;
    /**
     * Form section number (2, 3, 5, or 6)
     * @type {number}
     * @memberof MediaFile
     */
    sectionNumber: number;
    /**
     * Media category (e.g., 'hvac_photo', 'walkthrough_video')
     * @type {string}
     * @memberof MediaFile
     */
    mediaType: string;
    /**
     * Original filename from user
     * @type {string}
     * @memberof MediaFile
     */
    originalFilename: string;
    /**
     * MIME type (e.g., 'image/jpeg', 'video/mp4')
     * @type {string}
     * @memberof MediaFile
     */
    contentType: string;
    /**
     * File size in bytes
     * @type {number}
     * @memberof MediaFile
     */
    fileSize: number;
    /**
     * S3 key/path
     * @type {string}
     * @memberof MediaFile
     */
    s3Path: string;
    /**
     * 
     * @type {SignedUrl}
     * @memberof MediaFile
     */
    signedUrl?: SignedUrl;
    /**
     * 
     * @type {Note2}
     * @memberof MediaFile
     */
    note?: Note2;
    /**
     * 
     * @type {DurationSeconds1}
     * @memberof MediaFile
     */
    durationSeconds?: DurationSeconds1;
    /**
     * Upload timestamp
     * @type {Date}
     * @memberof MediaFile
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the MediaFile interface.
 */
export function instanceOfMediaFile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sectionNumber" in value;
    isInstance = isInstance && "mediaType" in value;
    isInstance = isInstance && "originalFilename" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "s3Path" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function MediaFileFromJSON(json: any): MediaFile {
    return MediaFileFromJSONTyped(json, false);
}

export function MediaFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sectionNumber': json['section_number'],
        'mediaType': json['media_type'],
        'originalFilename': json['original_filename'],
        'contentType': json['content_type'],
        'fileSize': json['file_size'],
        's3Path': json['s3_path'],
        'signedUrl': !exists(json, 'signed_url') ? undefined : SignedUrlFromJSON(json['signed_url']),
        'note': !exists(json, 'note') ? undefined : Note2FromJSON(json['note']),
        'durationSeconds': !exists(json, 'duration_seconds') ? undefined : DurationSeconds1FromJSON(json['duration_seconds']),
        'createdAt': (new Date(json['created_at'])),
    };
}

export function MediaFileToJSON(value?: MediaFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'section_number': value.sectionNumber,
        'media_type': value.mediaType,
        'original_filename': value.originalFilename,
        'content_type': value.contentType,
        'file_size': value.fileSize,
        's3_path': value.s3Path,
        'signed_url': SignedUrlToJSON(value.signedUrl),
        'note': Note2ToJSON(value.note),
        'duration_seconds': DurationSeconds1ToJSON(value.durationSeconds),
        'created_at': (value.createdAt.toISOString()),
    };
}

